import { render, staticRenderFns } from "./DialogoSinFotos.vue?vue&type=template&id=ae049cdc&scoped=true&"
import script from "./DialogoSinFotos.vue?vue&type=script&lang=ts&"
export * from "./DialogoSinFotos.vue?vue&type=script&lang=ts&"
import style0 from "./DialogoSinFotos.vue?vue&type=style&index=0&id=ae049cdc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae049cdc",
  null
  
)

export default component.exports